var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookitupSignet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bookitup-signet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.058,
    y1: 0.058,
    x2: 1.198,
    y2: 1.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fda632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5c5a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1",
    "data-name": "Rechteck 1",
    width: 600,
    height: 600,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_384",
    "data-name": "Gruppe 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_383",
    "data-name": "Gruppe 383",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M539.637,60.363C589.969,107.918,598.564,203.959,600,300c-1.436,96.041-10.031,192.082-60.363,239.638C492.082,589.97,396.041,598.565,300,600c-96.042-1.435-192.083-10.03-239.639-60.362C10.03,492.083,1.435,396.042,0,300,1.435,203.959,10.03,107.918,60.361,60.363,107.917,10.031,203.959,1.435,300,0c96.041,1.435,192.082,10.031,239.637,60.363",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_385",
    "data-name": "Gruppe 385",
    transform: "translate(174.298 133.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M489.168,324.807v1.871a125.867,125.867,0,0,0,9.705,49.679,122.259,122.259,0,0,0,26.8,39.745,124.236,124.236,0,0,0,17.1,14.1V354.961l-53.608-30.154Z",
    transform: "translate(-489.167 -119.181)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M561.442,364.541v75.805a132.41,132.41,0,0,0,13.846,6.829,122.472,122.472,0,0,0,39.764,9.385v-98l-16.747,16.349-6.736,6.574-8.2-4.614-21.926-12.333Z",
    transform: "translate(-498.804 -123.681)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M705.992,350.987v-78.62l36.392-35.528a130.129,130.129,0,0,1,17.16,28.893,126.879,126.879,0,0,1,0,98.434,127.339,127.339,0,0,1-26.8,39.745,124.755,124.755,0,0,1-26.749,20.324V350.987Z",
    transform: "translate(-518.076 -107.451)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M687.327,370.142V288l-53.61,52.336V447.471h.424a122.172,122.172,0,0,0,49.217-9.937q2.009-.87,3.969-1.8v-65.6Z",
    transform: "translate(-508.441 -114.273)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M542.776,87.547H489.167V282.813l53.609,30.154V87.547Z",
    transform: "translate(-489.167 -87.547)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M584.528,190.322a126.526,126.526,0,0,0-17.791,8.549q-2.78,1.62-5.3,3.317V330.706L590.1,346.827l24.949-24.356V182.5a93.219,93.219,0,0,0-10.882,1.811,138.069,138.069,0,0,0-19.642,6.008Z",
    transform: "translate(-498.804 -100.207)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M705.992,254.952V200.868a124.792,124.792,0,0,1,26.749,20.324q1.935,1.938,3.781,3.955l-30.529,29.805Z",
    transform: "translate(-518.076 -102.656)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M687.327,261.243V193.66q-1.963-.925-3.969-1.8a122.2,122.2,0,0,0-49.217-9.936h-.424v131.65l53.61-52.336Z",
    transform: "translate(-508.441 -100.13)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookitupSignet);
export default __webpack_public_path__ + "static/media/bookitup-signet.33f679025cb0868d0682e4b706312b92.svg";
export { ForwardRef as ReactComponent };